const NAV_SELECTOR = '.vm-main-nav';
const PARENT_ITEM_SELECTOR = 'li.fl-has-submenu';
const PANEL_SELECTOR = ':scope > ul.sub-menu';
const FLIPPED_CLASS = 'vm-main-nav-flipped';
const VIEWPORT_EDGE_GAP = 12;

/**
 * Flips one dropdown panel to open inwards when its default side leaves the viewport.
 */
function align_panel(parent_item: Element): void {
    const panel = parent_item.querySelector<HTMLElement>(PANEL_SELECTOR);
    if (!panel) {
        return;
    }

    panel.classList.remove(FLIPPED_CLASS);
    // Below the responsive breakpoint the panels stack as an accordion and never overflow.
    if (window.getComputedStyle(panel).position !== 'absolute') {
        return;
    }

    if (panel.getBoundingClientRect().right > window.innerWidth - VIEWPORT_EDGE_GAP) {
        panel.classList.add(FLIPPED_CLASS);
    }
}

/**
 * Realigns every panel, outer levels first so nested flyouts measure a settled parent.
 */
function align_all_panels(): void {
    document
        .querySelectorAll(`${NAV_SELECTOR} ${PARENT_ITEM_SELECTOR}`)
        .forEach(align_panel);
}

let resize_timer = 0;

/**
 * Debounces realignment so a drag-resize measures once the width settles.
 */
function schedule_realign(): void {
    window.clearTimeout(resize_timer);
    resize_timer = window.setTimeout(align_all_panels, 120);
}

align_all_panels();
window.addEventListener('resize', schedule_realign);
document.addEventListener('pointerover', (event) => {
    const target = event.target;
    if (target instanceof Element && target.closest(NAV_SELECTOR)) {
        align_all_panels();
    }
});

if (document.fonts) {
    document.fonts.ready.then(align_all_panels);
}
